// Phần THUẦN của "hàng đợi duyệt": tuổi chờ, mức khẩn của việc chờ, và bảng tóm tắt để người duyệt biết mình đang nợ bao nhiêu.
// Tuổi chờ lấy từ `cap_nhat_luc` — cùng mốc mà thẻ "chờ từ …" đang hiện (việc nằm ở “Chờ duyệt” từ lần cập nhật gần nhất).
import { thuTuUuTien, treHan, type Viec } from './viec';

/** Ngưỡng do VTask đặt (không phải chuẩn ngành): quá 3 ngày là chậm, quá 7 ngày là bị bỏ quên. Đổi ở đây là đổi cả màu thẻ lẫn tóm tắt. */
export const NGUONG_CHAM_NGAY = 3;
export const NGUONG_QUA_HAN_NGAY = 7;

export type MucTuoi = 'moi' | 'cham' | 'qua-han';

export const tuoiNgay = (iso: string, bay_gio = Date.now()): number => Math.max(0, (bay_gio - +new Date(iso)) / 86400_000);

/** Thứ tự hàng đợi duyệt: ưu tiên (Khẩn → Thấp), hạn gần trước (không hạn xuống cuối), rồi việc nằm lâu nhất trước.
 *  MỘT nguồn cho khối "Chờ bạn duyệt" ở Tổng quan và mục "Việc chờ quyết" của Báo cáo kỳ. */
export const thuTuDuyet = (a: Viec, b: Viec) =>
  thuTuUuTien(a.uu_tien) - thuTuUuTien(b.uu_tien) || (a.han || '9').localeCompare(b.han || '9') || a.cap_nhat_luc.localeCompare(b.cap_nhat_luc);

export function mucTuoi(iso: string, bay_gio = Date.now()): MucTuoi {
  const n = tuoiNgay(iso, bay_gio);
  return n >= NGUONG_QUA_HAN_NGAY ? 'qua-han' : n >= NGUONG_CHAM_NGAY ? 'cham' : 'moi';
}

/** "chờ 8 ngày" / "chờ 5 giờ" / "vừa chuyển" — ngắn, để đặt cạnh huy hiệu. */
export function chuTuoi(iso: string, bay_gio = Date.now()): string {
  const n = tuoiNgay(iso, bay_gio);
  if (n >= 1) return `chờ ${Math.floor(n)} ngày`;
  const gio = Math.floor(n * 24);
  return gio >= 1 ? `chờ ${gio} giờ` : 'vừa chuyển';
}

export interface TomTatHangDoi {
  tong: number;
  cham: number;       // chờ ≥ NGUONG_CHAM_NGAY (gồm cả quá hạn bỏ quên)
  qua_han: number;    // chờ ≥ NGUONG_QUA_HAN_NGAY
  khan: number;       // ưu tiên P0 / P1
  tre_han: number;    // có hạn và đã quá hạn
  cu_nhat_ngay: number | null;
  trung_vi_ngay: number | null;
}

const trungVi = (x: number[]): number | null => {
  if (!x.length) return null;
  const s = [...x].sort((a, b) => a - b), g = s.length >> 1;
  return s.length % 2 ? s[g] : (s[g - 1] + s[g]) / 2;
};

export function tomTatHangDoi(ds: readonly Viec[], bay_gio = Date.now()): TomTatHangDoi {
  const tuoi = ds.map((v) => tuoiNgay(v.cap_nhat_luc, bay_gio));
  return {
    tong: ds.length,
    cham: tuoi.filter((n) => n >= NGUONG_CHAM_NGAY).length,
    qua_han: tuoi.filter((n) => n >= NGUONG_QUA_HAN_NGAY).length,
    khan: ds.filter((v) => v.uu_tien === 'uu-tien:p0' || v.uu_tien === 'uu-tien:p1').length,
    tre_han: ds.filter(treHan).length,
    cu_nhat_ngay: tuoi.length ? Math.max(...tuoi) : null,
    trung_vi_ngay: trungVi(tuoi),
  };
}
